import React, { Suspense, useEffect, useState, lazy } from "react";

// Libraries
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import retina from "retinajs";
import { AnimatePresence } from "framer-motion";

// Context
import GlobalContext from "./Context/Context";

// Components
import ScrollToTopButton from "./Components/ScrollToTop"

// Home
const HomeJP = lazy(() => import("./Pages/HomeJP"))

// Service pages
const ServicePage = lazy(() => import("./Pages/ServicePage"))

// Contact
const ContactPage = lazy(() => import("./Pages/ContactPage"))
const ThankYouPage = lazy(() => import("./Pages/ThankYouPage"))

// Blog
const Blog = lazy(() => import("./Pages/Blog"))
const Article = lazy(() => import("./Pages/Article"))


// Additional Pages
const NotFoundPage = lazy(() => import("./Pages/404"))


function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customModal, setCustomModal] = useState({
    el: null,
    isOpen: false
  })
  const location = useLocation();

  // RetinaJS
  useEffect(() => {
    window.addEventListener('load', retina(document.querySelectorAll('img')));
  }, [])

  useEffect(() => {
    setTimeout(() => {
      import("./Functions/Utilities").then(module => {
        module.SetHeaderMenuPos()
        module.setDocumentFullHeight()
      })
    }, 1000);
  }, [location])

  // Scroll to anchor after page load
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1)
      const attempt = (tries) => {
        const el = document.getElementById(id)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        } else if (tries > 0) {
          setTimeout(() => attempt(tries - 1), 200)
        }
      }
      setTimeout(() => attempt(10), 300)
    } else {
      window.scrollTo(0, 0)
    }
  }, [location])

  useEffect(() => {
    if (isModalOpen === true) {
      document.querySelector("body").classList.add("overflow-hidden");
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }, [isModalOpen]);

  // Get the current location and set the window to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setFooterHeight(0);
    setCustomModal({
      ...customModal,
      el: null,
      isOpen: false
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <GlobalContext.Provider
      value={{
        headerHeight,
        setHeaderHeight,
        footerHeight,
        setFooterHeight,
        isModalOpen,
        setIsModalOpen,
        customModal,
        setCustomModal,
      }}
    >
      <div className="App" style={{ "--header-height": `${headerHeight}px` }}>
        {
          <main style={{ marginTop: headerHeight, marginBottom: footerHeight }}>
            <ScrollToTopButton />
            <AnimatePresence exitBeforeEnter>
              <Suspense fallback={<></>}>
                <Routes>
                  <Route path="/" element={<HomeJP style={{ "--base-color": "#FFFFFF" }} />} />
                  <Route path="/services/:serviceSlug" element={<ServicePage />} />
                  <Route path="/services/:serviceSlug/:regionSlug" element={<ServicePage />} />
                  <Route path="/nous-joindre" element={<ContactPage style={{ "--base-color": "#FFFFFF" }} />} />
                  <Route path="/merci" element={<ThankYouPage style={{ "--base-color": "#FFFFFF" }} />} />
                  <Route path="/page/error-404" element={<NotFoundPage style={{ "--base-color": "#FFD700" }} />} />
                  <Route path='*' element={<Navigate to='/' />} />
                  <Route path="/blog/" element={<Blog style={{ "--base-color": "#FFFFFF" }} />} />
                  <Route path="blog/article/:id" element={<Article style={{ "--base-color": "#FFFFFF" }} />} />
                </Routes>
              </Suspense>
            </AnimatePresence>
          </main>
        }
      </div>
    </GlobalContext.Provider >
  )
}

export default App;
